import "core-js/modules/es.array.slice.js";
import React from 'react';
import Box from 'components/Box';
import SmartBillboard from '../../shared/smartBillboard';
import SmartBillboardShared from '../../shared/smartBillboardShared';
import CollectionCarousel from './CollectionCarousel';
export var BillboardAndCarousel = function BillboardAndCarousel(_ref) {
  var items = _ref.items,
    isShared = _ref.isShared,
    qaIdContext = _ref.qaIdContext;
  return /*#__PURE__*/React.createElement(React.Fragment, null, isShared ? /*#__PURE__*/React.createElement(SmartBillboardShared, {
    item: items[0]
  }) : /*#__PURE__*/React.createElement(SmartBillboard, {
    item: items[0]
  }), items.length > 1 && /*#__PURE__*/React.createElement(Box, {
    pt: "l"
  }, /*#__PURE__*/React.createElement(CollectionCarousel, {
    large: true,
    items: items.slice(1),
    isShared: isShared,
    qaIdContext: qaIdContext
  })));
};
export default BillboardAndCarousel;